import React from "react";
import { useState } from "react";
// import "react-datepicker/dist/react-datepicker.css";
import { Col, Row } from "reactstrap";
import Button from "../../../../../components/Button";
import TextArea from "../../../../../components/textArea/TextArea";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FinetuneIconLn from "./previewSetting/FinetuneIconLn";
import DateTimePicker from "react-datetime-picker";
import dummyimg from "../../../../../assets/img/dummyimg.png";

const FineTuneLinkedin = ({
  socialchannel,
  setOpenModal,
  activeTab,
  setActiveTab,
  postDate,
  caption,
  linkedinData,
  images,
  selectedAccountSocials,
}) => {
  const [linkedinStartDate, setLinkedinStartDate] = useState(postDate);
  const [linkedinCaption, setLinkedinCaption] = useState(caption);
  const [count, setCount] = useState(2200);

  const onChangeTextArea = (e) => {
    const value = e.target.value;
    const valueLength = e.target.value.length;
    setLinkedinCaption(value);
    setCount(2200 - valueLength);
  };

  const nextButton = (tab) => {
    if (socialchannel.length === activeTab) {
      linkedinData(linkedinCaption, linkedinStartDate);
      setOpenModal(true);
    } else {
      if (activeTab !== tab) {
        linkedinData(linkedinCaption, linkedinStartDate);
        setActiveTab(tab);
      }
    }
  };
  return (
    <div className="finetuneTabContent">
      <Row>
        <Col xs="12" md="7" sm="12">
          <div className="previewWrapper">
            <h2> Preview www</h2>
            <div className="preview-fb-wrapper">
              <div className="preview-dp-wrapper mb-3">
                <div className="dp">
                  <img
                    src={
                      selectedAccountSocials?.linkedin?.company_logo || dummyimg
                    }
                    alt="dp"
                  />
                </div>
                <div>
                  {selectedAccountSocials?.linkedin?.company_name ? (
                    <span>
                      {selectedAccountSocials?.linkedin?.company_name}
                    </span>
                  ) : null}
                </div>
              </div>
              <div>
                <p
                  className="previewText"
                  dangerouslySetInnerHTML={{
                    __html: JSON.stringify(linkedinCaption)
                      .replace(/\\n/g, "<br>")
                      ?.replaceAll('"', ""),
                  }}
                />
              </div>
              <div>
                <Carousel showThumbs={false} infiniteLoop={true} autoPlay>
                  {images?.map((image, index) => {
                    return (
                      <div className="img-holder" key={index}>
                        {image?.type.slice(0, 5) === "video" ? (
                          <video width="100%" height="100%" controls autoplay>
                            <source
                              src={URL.createObjectURL(image)}
                              type={`video/${image?.name.slice(-3)}`}
                            />
                          </video>
                        ) : (
                          <img src={URL.createObjectURL(image)} alt="" />
                        )}
                      </div>
                    );
                  })}
                </Carousel>
              </div>
              <FinetuneIconLn />
            </div>
          </div>
        </Col>
        <Col xs="12" md="5" sm="12">
          <div>
            <DateTimePicker
              dayPlaceholder="dd"
              monthPlaceholder="mm"
              yearPlaceholder="yy"
              hourPlaceholder="hh"
              minutePlaceholder="mm"
              onChange={(date) => setLinkedinStartDate(date)}
              value={linkedinStartDate}
              clearIcon={null}
              calendarIcon={null}
              disableClock={true}
              minDate={new Date()}
              className="scheduleDateInput"
            />
            <br />
            <br />
            <TextArea
              maxLength="2200"
              placeholder="Caption"
              value={linkedinCaption?.replaceAll('"', "")}
              onChangeTextArea={onChangeTextArea}
              count={count}
            />
            <Button
              text="Next"
              onButtonClick={() => nextButton(activeTab + 1)}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FineTuneLinkedin;
